import React from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

const ActionBarPlaceHolder = () => {
  return (
    <div className="sui-w-full">
      <Skeleton
        disablePadding="x"
        orientation="horizontal"
        PaperProps={{
          className: 'sui-w-full sui-border-b-1 sui-border-solid sui-border-primary',
          variant: 'shadow'
        }}
      >
        <SkeletonBlock aspect="wide" variant="rectangular" height={20} />
      </Skeleton>
    </div>
  );
};

ActionBarPlaceHolder.displayName = 'ActionBarPlaceHolder';

export { ActionBarPlaceHolder };
